import { useEffect, useState } from 'react';
import { Header } from 'components';
import { AmDonutChart3D } from 'components/amcharts/donutChart';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
// import { colorTheme } from 'theme';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';
import { strings } from 'i18n/Strings';

import { updateEmployee, getUserChart, getContributionChart } from 'service/';
import { notifications } from 'utils/firebase';
import { getToken, onMessage } from 'firebase/messaging';
import { type RootState } from 'store';
import { useSelector } from 'react-redux';
import { FIREBASE_VAPID_KEY } from 'utils/Constants';

interface ChartType {
  category: string;
  value: number;
}

Chart.register(ChartDataLabels);

const Home = (): JSX.Element => {
  const { empId } = useSelector((state: RootState) => state.onboarding);

  const [userChart, setUserChart] = useState<ChartType[]>([]);
  // const [loading, setLoading] = useState(false);
  const [contributionLoading, setContributionLoading] = useState(false);
  const [userLoading, setUserLoading] = useState(false);
  const [contributionChart, setContributionChart] = useState<ChartType[]>([]);

  if ('Notification' in window) {
    // Check if the Notification API is supported by the browser

    if (Notification.permission === 'granted') {
      // Permission has already been granted
      // You can proceed with sending push notifications
      // or perform any other actions
      getToken(notifications, {
        vapidKey: FIREBASE_VAPID_KEY,
      })
        .then(async (currentToken) => {
          if (currentToken) {
            await updateEmployee(Number(empId), { fcmToken: currentToken });
          }
        })
        .catch((err) => err);
    } else {
      if (Notification.permission !== 'denied') {
        // Permission has not been granted or denied yet
        // You can request permission from the user

        Notification.requestPermission()
          .then((permission) => {
            if (permission === 'granted') {
              getToken(notifications, {
                vapidKey: FIREBASE_VAPID_KEY,
              })
                .then(async (currentToken) => {
                  if (currentToken) {
                    await updateEmployee(Number(empId), {
                      fcmToken: currentToken,
                    });
                  }
                })
                .catch((err) => err);
            }
          })
          .catch((error) => error);
      }
    }
  }
  useEffect(() => {
    onMessage(notifications, (payload) => {
      console.log('Message received.');
    });
    void getUser();
    void getContribution();
  }, []);

  const getUser = async (): Promise<void> => {
    setUserLoading(true);
    try {
      const { data } = await getUserChart();
      if (data) {
        setUserChart([
          {
            category: strings.displayText.noOfRegisteredUser,
            value: data?.registeredUserCount || 0,
          },
          {
            category: strings.displayText.noOfUnRegisteredUser,
            value: data?.unRegisteredUserCount || 0,
          },
        ]);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setUserLoading(false);
    }
  };
  const getContribution = async (): Promise<void> => {
    try {
      setContributionLoading(true);
      const { data } = await getContributionChart();
      if (data) {
        setContributionChart([
          {
            category: strings.displayText.noOfUserContributed,
            value: data?.noOfUserContributed || 0,
          },
          {
            category: strings.displayText.noOfUserNotContributed,
            value: data?.noOfUserNotContributed || 0,
          },
        ]);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setContributionLoading(false);
    }
  };

  return (
    <Box>
      <Header title="Home" subtitle="" />
      {userLoading || contributionLoading ? null : (
        <Grid container spacing={2} direction="row">
          <Grid item xs={12} md={6}>
            <AmDonutChart3D
              id="chart1"
              data={userChart}
              height="500px"
              colors={['#B5DFC8', '#EEC033']}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <AmDonutChart3D
              id="chart2"
              data={contributionChart}
              height="500px"
              colors={['#B5DFC8', '#EEC033']}
            />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default Home;
